import React from 'react';
import { ChevronDownIcon, TruckIcon } from 'lucide-react';
export const ShippingDiscounts = ({
  formatPrice,
  showVat
}) => {
  const getVatAdjustedPrice = price => {
    return showVat ? price : Math.round(price / 1.25);
  };
  const shippingCost = 1200;
  const shippingCharged = 800;
  const shippingDB = shippingCost - shippingCharged;
  const discounts = [{
    type: 'Årsrabat 5%',
    amount: 9475
  }, {
    type: 'Fast rabat',
    amount: 2500
  }];
  const categoryDiscounts = [{
    category: 'Rør/Manifolder',
    listPrice: 48500,
    discountPercent: 10,
    discountAmount: 4850,
    netPrice: 43650
  }, {
    category: 'Styring/WiFi-termostater',
    listPrice: 15800,
    discountPercent: 8,
    discountAmount: 1264,
    netPrice: 14536
  }, {
    category: 'Fordelere & ventiler',
    listPrice: 12500,
    discountPercent: 5,
    discountAmount: 625,
    netPrice: 11875
  }, {
    category: 'Pumper/varmeveksler',
    listPrice: 8700,
    discountPercent: 7,
    discountAmount: 609,
    netPrice: 8091
  }];
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-179">
      <div className="p-6" data-id="element-180">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-181">
          Fragt & rabatter
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-182">
          <div className="space-y-4" data-id="element-183">
            <div className="flex items-center gap-3 mb-2" data-id="element-184">
              <TruckIcon className="h-5 w-5 text-gray-400" data-id="element-185" />
              <h3 className="font-medium text-gray-900" data-id="element-186">Fragtinformation</h3>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-187">
              <div className="flex justify-between" data-id="element-188">
                <span className="text-sm text-gray-600" data-id="element-189">Fragt (cost)</span>
                <span className="text-sm font-medium" data-id="element-190">
                  {formatPrice(getVatAdjustedPrice(shippingCost))}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-191">
                <span className="text-sm text-gray-600" data-id="element-192">
                  Fragt (faktureret)
                </span>
                <span className="text-sm font-medium" data-id="element-193">
                  {formatPrice(getVatAdjustedPrice(shippingCharged))}
                </span>
              </div>
              <div className="flex justify-between pt-2 border-t border-gray-200" data-id="element-194">
                <span className="text-sm font-medium text-gray-900" data-id="element-195">
                  Fragt DB
                </span>
                <span className="text-sm font-medium text-green-600" data-id="element-196">
                  {formatPrice(getVatAdjustedPrice(shippingDB))}
                </span>
              </div>
            </div>
          </div>
          <div className="space-y-4" data-id="element-197">
            <h3 className="font-medium text-gray-900" data-id="element-198">Rabatter</h3>
            <div className="flex flex-wrap gap-2" data-id="element-199">
              {discounts.map((discount, index) => <div key={index} className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800" data-id="element-200">
                  {discount.type}:{' '}
                  {formatPrice(getVatAdjustedPrice(discount.amount))}
                </div>)}
            </div>
            <div className="mt-4" data-id="element-201">
              <button className="flex items-center text-sm text-gray-600 hover:text-gray-900" data-id="element-202">
                <span data-id="element-203">Vis kategorirabatter</span>
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-204" />
              </button>
              <div className="mt-2 overflow-x-auto" data-id="element-205">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-206">
                  <thead className="bg-gray-50" data-id="element-207">
                    <tr data-id="element-208">
                      <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-209">
                        Kategori
                      </th>
                      <th scope="col" className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-210">
                        Listepris
                      </th>
                      <th scope="col" className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-211">
                        Rabat %
                      </th>
                      <th scope="col" className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-212">
                        Rabat kr.
                      </th>
                      <th scope="col" className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-213">
                        Netto
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-214">
                    {categoryDiscounts.map((item, index) => <tr key={index} data-id="element-215">
                        <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-216">
                          {item.category}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-right" data-id="element-217">
                          {formatPrice(getVatAdjustedPrice(item.listPrice))}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-right" data-id="element-218">
                          {item.discountPercent.toFixed(2)}%
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-right" data-id="element-219">
                          {formatPrice(getVatAdjustedPrice(item.discountAmount))}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-right" data-id="element-220">
                          {formatPrice(getVatAdjustedPrice(item.netPrice))}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
              <p className="mt-2 text-xs text-gray-500 italic" data-id="element-221">
                Priser dynamisk opdateret
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};